export const articles: {
  [key: string]: { intercom: number; elevio?: number; name: string };
} = {
  ccError: {
    intercom: 11424392,
    elevio: 36353,
    name: 'credit-card-error-message-transaction-not-approved'
  },
  pauseAccount: {
    intercom: 11424396,
    elevio: 84826,
    name: 'pause-your-account'
  },
  accountInvoices: {
    intercom: 11424399,
    elevio: 84828,
    name: 'accessing-your-account-invoices'
  },
  closeAccount: {
    intercom: 11424403,
    elevio: 84829,
    name: 'how-to-close-your-account'
  },
  offerDiscount: {
    intercom: 11424408,
    elevio: 84856,
    name:
      'does-bugherd-offer-a-discount-for-not-for-profits-or-education-providers'
  },
  transferOwnership: {
    intercom: 11424410,
    elevio: 84889,
    name: 'transferring-ownership-of-your-bugherd-account'
  },
  seeOtherClientsFeedback: {
    intercom: 11424216,
    elevio: 84854,
    name: 'how-to-allow-disallow-clients-to-see-feedback-from-other-clients'
  },
  allowClientsToSeeMembersFeedback: {
    intercom: 11424297,
    elevio: 84898,
    name: 'how-to-allow-clients-to-see-member-feedback'
  },
  shareDeliverables: {
    intercom: 11424306,
    elevio: 84974,
    name: 'share-deliverables-with-clients-or-guests-for-feedback'
  },
  clientFeedbackOnWebsitesAndFiles: {
    intercom: 11424313,
    elevio: 84999,
    name: 'get-feedback-from-clients-on-websites-and-files'
  },
  manageClientPermissions: {
    intercom: 11424318,
    elevio: 85000,
    name: 'manage-client-permissions'
  },
  createTasksViaEmail: {
    intercom: 11424233,
    elevio: 33902,
    name: 'create-bugherd-tasks-from-email'
  },
  keyboardShortcutsForCreatingTasks: {
    intercom: 11424264,
    elevio: 84855,
    name: 'keyboard-shortcuts-for-creating-tasks'
  },
  giveFeedbackOrLogBug: {
    intercom: 11424269,
    elevio: 84858,
    name: 'how-do-i-give-feedback-or-log-a-bug'
  },
  feedbackViaMobileOrTablet: {
    intercom: 11424274,
    elevio: 84888,
    name: 'leaving-feedback-using-a-mobile-phone-or-tablet'
  },
  createTaskImprovements: {
    intercom: 11424287,
    elevio: 84919,
    name: '7-create-task-improvements-you-asked-for'
  },
  switchProjectViaExtension: {
    intercom: 11424290,
    elevio: 84985,
    name: 'how-to-switch-bugherd-projects-from-the-extension'
  },
  invitedWebsiteFeedback: {
    intercom: 11424323,
    elevio: 84870,
    name: 'invited-to-give-website-feedback-with-bugherd-let-s-get-started'
  },
  clientProjectBoard: {
    intercom: 11424343,
    elevio: 85001,
    name: 'welcome-to-your-client-project-board'
  },
  installViaJavascript: {
    intercom: 11424426,
    elevio: 33871,
    name: 'installing-bugherd-using-javascript'
  },
  browserExtensions: {
    intercom: 11424451,
    elevio: 33880,
    name: 'bugherd-browser-extensions'
  },
  chromeBrowserExtension: {
    intercom: 11424458,
    elevio: 33884,
    name: 'how-to-install-bugherd-s-chrome-browser-extension'
  },
  scriptOnMultipleWebsites: {
    intercom: 11424462,
    elevio: 36431,
    name: 'can-i-install-my-project-s-embed-script-on-multiple-websites'
  },
  microsoftEdgeBrowserExtension: {
    intercom: 11425571,
    elevio: 84863,
    name: 'how-to-install-bugherd-s-microsoft-edge-browser-extension'
  },
  bugherdWordpressPlugin: {
    intercom: 11425578,
    elevio: 84872,
    name: 'install-the-bugherd-wordpress-plugin'
  },
  bugherdInGoogleTagManager: {
    intercom: 11425594,
    elevio: 84875,
    name: 'install-bugherd-in-google-tag-manager'
  },
  safariBrowserExtension: {
    intercom: 11425610,
    elevio: 84876,
    name: 'how-to-install-the-safari-extension-on-your-browser'
  },
  extensionOrInstallBugherd: {
    intercom: 11425649,
    elevio: 84883,
    name: 'get-the-extension-or-install-bugherd'
  },
  firefoxBrowserExtension: {
    intercom: 11425672,
    elevio: 84901,
    name: 'how-to-install-bugherd-s-firefox-browser-extension'
  },
  usingGit: {
    intercom: 11430515,
    elevio: 33869,
    name: 'using-github-gitlab-and-bitbucket-commit-hooks'
  },
  githubIntegration: {
    intercom: 11430519,
    elevio: 33875,
    name: 'bugherd-and-github-integration'
  },
  drupal: {
    intercom: 11430523,
    elevio: 33882,
    name: 'bugherd-and-drupal'
  },
  howToUseZapier: {
    intercom: 11430530,
    elevio: 33883,
    name: 'how-to-use-zapier-with-bugherd'
  },
  basecampIntegration: {
    intercom: 11430534,
    elevio: 33886,
    name: 'basecamp-integration-setup-guide'
  },
  findAPIDocs: {
    intercom: 11430536,
    elevio: 36432,
    name: 'where-can-i-find-your-api-docs'
  },
  slackIntegration: {
    intercom: 11430538,
    elevio: 84823,
    name: 'bugherd-and-slack-integration-setup-guide'
  },
  bugherdIntegrateWith: {
    intercom: 11430542,
    elevio: 84824,
    name: 'what-services-does-bugherd-integrate-with'
  },
  zapierTriggersActionAPIReferences: {
    intercom: 11430545,
    elevio: 84850,
    name: 'bugherd-zapier-triggers-action-api-references'
  },
  useMakeWithBugherd: {
    intercom: 11430552,
    elevio: 84873,
    name: 'how-to-use-make-with-bugherd'
  },
  jiraIntegration: {
    intercom: 11430555,
    elevio: 84902,
    name: 'bugherd-and-jira-integration'
  },
  asanaIntegration: {
    intercom: 11430560,
    elevio: 84905,
    name: 'bugherd-and-asana-integration'
  },
  treloIntegration: {
    intercom: 11430565,
    elevio: 84906,
    name: 'bugherd-and-trello-integration'
  },
  fullStoryIntegration: {
    intercom: 11430568,
    elevio: 84908,
    name: 'bugherd-and-fullstory-integration'
  },
  logRocketIntegration: {
    intercom: 11430571,
    elevio: 84909,
    name: 'bugherd-and-logrocket-integration'
  },
  lambdaTestIntegration: {
    intercom: 11430572,
    elevio: 84916,
    name: 'bugherd-and-lambdatest-integration'
  },
  harvestIntegration: {
    intercom: 11430577,
    elevio: 84964,
    name: 'bugherd-and-harvest-integration'
  },
  linearIntegration: {
    intercom: 11430580,
    elevio: 84989,
    name: 'bugherd-and-linear-integration'
  },
  clickUpIntegration: {
    intercom: 11430592,
    elevio: 84991,
    name: 'bugherd-and-clickup-integration'
  },
  mondayDotComIntegration: {
    intercom: 11430610,
    elevio: 84992,
    name: 'bugherd-and-monday-com-integration'
  },
  microsoftTeamsIntegration: {
    intercom: 11430616,
    elevio: 84998,
    name: 'bugherd-and-microsoft-teams-integration'
  },
  productiveIntegration: {
    intercom: 11430618,
    elevio: 85002,
    name: 'bugherd-and-productive-integration'
  },
  teamworkIntegration: {
    intercom: 11430627,
    elevio: 85007,
    name: 'bugherd-and-teamwork'
  },
  differentBugStates: {
    intercom: 11430490,
    elevio: 33868,
    name: 'what-do-the-different-bug-states-mean'
  },
  taskEmailNotificationsSent: {
    intercom: 11430498,
    elevio: 33888,
    name: 'when-are-task-email-notifications-sent'
  },
  deletingTasks: {
    intercom: 11430506,
    elevio: 84851,
    name: 'deleting-tasks-from-the-task-board'
  },
  yourTasksDashboard: {
    intercom: 11430508,
    elevio: 84874,
    name: 'view-all-your-tasks-with-the-dashboard'
  },
  yourTaskBoardSetup: {
    intercom: 11430513,
    elevio: 84877,
    name: 'setting-up-your-task-board'
  },
  archivedTasksVisibleSidebar: {
    intercom: 11430524,
    elevio: 84903,
    name: 'how-long-do-archived-tasks-remain-visible-in-the-sidebar-task-list'
  },
  updateMultipleTasks: {
    intercom: 11430539,
    elevio: 84913,
    name: 'update-multiple-tasks'
  },
  commentsMentionsNotifications: {
    intercom: 11430544,
    elevio: 84984,
    name: 'notifications-for-new-comments-and-mentions-in-bugherd'
  },
  commentOnTasks: {
    intercom: 11430558,
    elevio: 84996,
    name: 'comment-on-tasks'
  },
  exportBugs: {
    intercom: 11430562,
    elevio: 84896,
    name: 'how-to-export-your-bugs-from-bugherd'
  },
  settingUpWebsiteURLs: {
    intercom: 11424211,
    elevio: 33865,
    name: 'guide-to-setting-up-website-urls-for-your-bugherd-projects'
  },
  projectKey: {
    intercom: 11467042,
    elevio: 84871,
    name: 'where-can-i-find-my-project-key'
  },
  oneOrTwoProjects: {
    intercom: 11424299,
    elevio: 36430,
    name:
      'i-have-a-staging-and-production-environment-should-i-create-one-or-two-projects'
  },
  userRolesInBugherd: {
    intercom: 11424346,
    elevio: 84839,
    name:
      'what-s-the-difference-between-members-clients-and-other-user-roles-in-bugherd'
  },
  userAccessToProjects: {
    intercom: 11424353,
    elevio: 84840,
    name: 'how-to-manage-user-access-to-projects'
  },
  inviteUsersToBugherd: {
    intercom: 11424357,
    elevio: 84841,
    name: 'how-to-invite-users-to-bugherd'
  },
  disableEnableProject: {
    intercom: 11424361,
    elevio: 84845,
    name: 'how-to-disable-enable-a-project'
  },
  companyLogo: {
    intercom: 11425072,
    elevio: 84853,
    name: 'adding-your-company-logo-to-bugherd'
  },
  firstProject: {
    intercom: 11425104,
    elevio: 84882,
    name: 'set-up-your-first-project-in-bugherd'
  },
  internalWebsites: {
    intercom: 11425125,
    elevio: 84884,
    name: 'using-bugherd-on-internal-websites-or-localhost'
  },
  settingUpSSO: {
    intercom: 11425133,
    elevio: 84900,
    name: 'setting-up-sso-for-your-bugherd-organization'
  },
  sidebarSettings: {
    intercom: 11425144,
    elevio: 84907,
    name: 'sidebar-settings'
  },
  sendFeedbackInGerman: {
    intercom: 11430440,
    elevio: 33889,
    name: 'send-feedback-in-german-deutsch'
  },
  sendFeedbackInAustralian: {
    intercom: 11430448,
    elevio: 33890,
    name: 'send-feedback-in-australian'
  },
  modifyingPublicFeedbackText: {
    intercom: 11430451,
    elevio: 33891,
    name: 'modifying-the-text-of-the-public-feedback-ui'
  },
  sendFeedbackInDutch: {
    intercom: 11430461,
    elevio: 33892,
    name: 'send-feedback-in-dutch-nederlands'
  },
  sendFeedbackInFrench: {
    intercom: 11430463,
    elevio: 33893,
    name: 'send-feedback-in-french-francais'
  },
  sendFeedbackInBrazilianPortuguese: {
    intercom: 11430466,
    elevio: 33894,
    name: 'send-feedback-in-brazilian-portuguese-portugues-do-brasil'
  },
  sendFeedbackInHungarian: {
    intercom: 11430468,
    elevio: 33895,
    name: 'send-feedback-in-hungarian-magyar'
  },
  sendFeedbackInSpanish: {
    intercom: 11430472,
    elevio: 33896,
    name: 'send-feedback-in-spanish-espa-ol'
  },
  customiseSendFeedbackTab: {
    intercom: 11430476,
    elevio: 33897,
    name: 'customise-the-send-feedback-tab'
  },
  populateReportersEmailAddress: {
    intercom: 11430483,
    elevio: 33899,
    name: 'public-feedback-tab-how-to-pre-populate-the-reporter-s-email-address'
  },
  settingUpPublicFeedbackTab: {
    intercom: 11430485,
    elevio: 36352,
    name: 'setting-up-bugherd-s-public-feedback-tab'
  },
  sidebarIsntAppearing: {
    intercom: 11430737,
    elevio: 33898,
    name: 'help-the-bugherd-sidebar-isn-t-appearing'
  },
  bugherdWithMobile: {
    intercom: 11430735,
    elevio: 84825,
    name: 'can-i-use-bugherd-with-mobile'
  },
  delayLoading: {
    intercom: 11430729,
    elevio: 84830,
    name: 'delay-loading-of-bugherd-script-on-your-site'
  },
  screenshotNotCapture: {
    intercom: 11430716,
    elevio: 84832,
    name: 'why-did-my-screenshot-not-capture-in-bugherd'
  },
  reinstallBrowserExtensions: {
    intercom: 11430713,
    elevio: 84834,
    name: 're-install-browser-extensions'
  },
  contentSecurityPolicy: {
    intercom: 11430711,
    elevio: 84837,
    name: 'content-security-policy-csp'
  },
  projectCoverPhoto: {
    intercom: 11430708,
    elevio: 84838,
    name: 'why-isn-t-my-project-cover-photo-appearing'
  },
  bugherdBlocked: {
    intercom: 11430702,
    elevio: 84846,
    name: 'why-is-bugherd-blocked-from-loading-on-my-website'
  },
  customizingMetadata: {
    intercom: 11430697,
    elevio: 84847,
    name: 'customizing-the-metadata-captured-by-bugherd'
  },
  extensionLongLoadTime: {
    intercom: 11430693,
    elevio: 84848,
    name: 'why-is-the-bugherd-browser-extension-taking-a-long-time-to-load'
  },
  noProjectForURL: {
    intercom: 11430681,
    elevio: 84849,
    name: 'why-am-i-seeing-a-no-project-for-this-url-message-in-bugherd'
  },
  bugherdDown: {
    intercom: 11430676,
    elevio: 84857,
    name: 'is-bugherd-down'
  },
  reenableMicrophone: {
    intercom: 11430673,
    elevio: 84864,
    name: 'how-do-i-re-enable-my-microphone'
  },
  verifyBugherdBehingBasicAuth: {
    intercom: 11430664,
    elevio: 84867,
    name:
      'how-to-verify-you-ve-installed-the-bugherd-javascript-correctly-if-your-site-is-behind-basic-authentication'
  },
  weCouldntFindWebsite: {
    intercom: 11430662,
    elevio: 84878,
    name: 'what-does-we-couldn-t-find-this-website-mean'
  },
  videoFeedbackMacOSPermissions: {
    intercom: 11430658,
    elevio: 84885,
    name: 'video-feedback-and-mac-os-system-permissions'
  },
  bugherdOnHTTP: {
    intercom: 11430650,
    elevio: 84886,
    name: 'why-can-t-i-use-bugherd-on-my-http-website'
  },
  microphoneScreenRecordingPermissions: {
    intercom: 11430643,
    elevio: 84887,
    name: 'how-to-enable-your-microphone-or-screen-recording-for-video-feedback'
  },
  loadingInSafari: {
    intercom: 11430642,
    elevio: 84890,
    name: 'why-isn-t-bugherd-loading-in-safari'
  },
  youDontHaveAccess: {
    intercom: 11430640,
    elevio: 84891,
    name: 'why-am-i-seeing-the-you-don-t-have-access-to-this-project'
  },
  testNativeApp: {
    intercom: 11430635,
    elevio: 84892,
    name: 'can-i-use-bugherd-to-test-a-native-app'
  },
  loginWithSSO: {
    intercom: 11430631,
    elevio: 84899,
    name: 'login-with-single-sign-on-sso'
  },
  browserDeveloperConsole: {
    intercom: 11430622,
    elevio: 84904,
    name: 'how-to-find-your-browser-s-developer-console'
  },
  bugherdOnModals: {
    intercom: 11430604,
    elevio: 84910,
    name: 'using-bugherd-on-modals'
  },
  loginViaGoogleOrMicrosoft: {
    intercom: 11430600,
    elevio: 84963,
    name: 'log-in-to-bugherd-with-your-google-or-microsoft-account'
  },
  referAndEarn: {
    intercom: 11430595,
    elevio: 85003,
    name: 'how-do-i-refer-earn'
  },
  manuallyInstallChromeExtension: {
    intercom: 11430590,
    elevio: 85005,
    name: 'how-to-manually-install-the-bugherd-chrome-extension'
  },
  updatingBrowserExtension: {
    intercom: 11430584,
    elevio: 85006,
    name: 'updating-the-bugherd-browser-extension'
  },
  screenshotNotLookAsExpected: {
    intercom: 11430582,
    elevio: 85010,
    name: 'why-does-my-screenshot-not-look-as-expected'
  },
  customDataWithNewBugs: {
    intercom: 11430441,
    elevio: 33900,
    name: 'capture-custom-data-with-new-bugs'
  },
  feedbackURL: {
    intercom: 11430433,
    elevio: 84868,
    name: 'what-is-my-feedback-url-and-why-is-it-important'
  },
  manageURLs: {
    intercom: 11430421,
    elevio: 84880,
    name: 'how-to-add-remove-and-edit-urls-in-your-project'
  },
  supportedURLs: {
    intercom: 11430410,
    elevio: 84881,
    name: 'what-urls-does-bugherd-support'
  },
  feedbackOnWebsitesAndFiles: {
    intercom: 11430390,
    elevio: 84911,
    name: 'get-feedback-on-websites-and-files-with-bugherd'
  },
  managingWebsitesAndFiles: {
    intercom: 11430387,
    elevio: 84973,
    name: 'uploading-and-managing-websites-and-files'
  },
  feedbackOnDesignsAndFiles: {
    intercom: 11430383,
    elevio: 84975,
    name: 'leave-feedback-on-designs-and-files'
  },
  manageFeedbackOnDeliverables: {
    intercom: 11430380,
    elevio: 84976,
    name: 'view-and-manage-feedback-on-deliverables'
  },
  addWebsiteOrFile: {
    intercom: 11430370,
    elevio: 84994,
    name: 'add-a-website-design-pdf-or-image'
  },
  introduction: {
    intercom: 11467098,
    name: 'introduction'
  },
  startingNewProject: {
    intercom: 11467109,
    name: 'chapter-1-starting-a-new-project'
  },
  installingBugherd: {
    intercom: 11467130,
    name: 'chapter-2-installing-bugherd'
  },
  defineYourWorkflow: {
    intercom: 11467159,
    name: 'chapter-3-define-your-workflow'
  },
  invitingYourTeam: {
    intercom: 11467170,
    name: 'chapter-4-inviting-your-team'
  },
  managingFeedback: {
    intercom: 11467195,
    name: 'chapter-5-managing-your-feedback-efficiently'
  },
  sharingWithYourClient: {
    intercom: 11467112,
    name: 'chapter-6-sharing-with-your-client'
  },
  clientFeedbackTips: {
    intercom: 11468121,
    name: 'chapter-7-tips-for-managing-client-feedback'
  }
};
